import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue"
import {
  ScopeServiceGroupsQuery,
  ScopeServiceGroupsQueryQuery,
  CreateScopeServiceMutation,
  CreateScopeServiceMutationMutation,
  CreateScopeServiceMutationMutationVariables,
  ScopeServicesListQuery,
  ScopeService,
  UpdateScopeServiceMutation,
  UpdateScopeServiceMutationMutation,
  ScopeServiceInput,
} from "@/gql"
import Checkbox from "@/components/widgets/input/Checkbox.vue"
import MoneyInput from "@/components/widgets/input/MoneyInput.vue"
import { useQuery } from "@vue/apollo-composable"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopeServiceForm',
  props: {
    service: null
  },
  emits: ["close", "save"],
  setup(__props: any, { emit }) {

const props = __props as {
  service?: ScopeService | null
}





const { addSuccess } = useNotification()
const { mutate } = useMutation()
const { loading, onResult } = useQuery<ScopeServiceGroupsQueryQuery>(ScopeServiceGroupsQuery)

const isSaving = ref(false)
const observer = ref(null)
const serviceGroups = ref<ScopeServiceGroupsQueryQuery["scopeServiceGroups"]>([])

onResult((result) => {
  if (result.data.scopeServiceGroups) {
    serviceGroups.value = result.data.scopeServiceGroups
  }
})

const defaultForm: ScopeServiceInput = {
  name: "",
  description: "",
  scopeServiceGroupId: null,
  availableForMissions: true,
  averageDuration: null,
  priceMax: {
    amount: null,
    currency: "USD",
  } as any,
  priceMin: {
    amount: null,
    currency: "USD",
  } as any,
}

const form = ref<ScopeServiceInput>({
  ...defaultForm,
})

const populateForm = () => {
  if (props.service) {
    form.value = {
      name: props.service.name,
      description: props.service.description,
      scopeServiceGroupId: props.service.serviceGroup.id,
      availableForMissions: props.service.availableForMissions,
      averageDuration: props.service.averageDuration || null,
      priceMax: {
        amount: props.service?.priceMax?.amount || 0,
        currency: props.service?.priceMax?.currency || "USD",
      },
      priceMin: {
        amount: props.service?.priceMin?.amount || 0,
        currency: props.service?.priceMin?.currency || "USD",
      },
    }
  } else {
    form.value = {
      ...defaultForm,
    }
  }
}

const refetchQueries = computed(() => {
  return [
    {
      query: ScopeServicesListQuery,
    },
  ]
})

const onSave = async () => {
  const validity = await (observer.value as any).validateWithInfo()

  if (!validity.isValid) return

  //Check if form input changed
  if (!validity.flags.changed) {
    emit("save")
    return
  }

  if (props.service?.id) {
    updateService()
  } else {
    createService()
  }
}

const createService = async () => {
  isSaving.value = true

  const {
    name,
    description,
    scopeServiceGroupId,
    availableForMissions,
    averageDuration,
    priceMax,
    priceMin,
  } = form.value

  const result = await mutate<
    CreateScopeServiceMutationMutation,
    CreateScopeServiceMutationMutationVariables
  >({
    mutation: CreateScopeServiceMutation,
    variables: {
      scopeServiceInput: {
        name,
        description,
        scopeServiceGroupId,
        availableForMissions,
        averageDuration,
        priceMax,
        priceMin,
      },
    },
    refetchQueries: refetchQueries.value,
  })

  if (result?.data?.createScopeService?.scopeService) {
    emit("save")
    addSuccess("Service created successfully")
    reset()
  }
  isSaving.value = false
}

const updateService = async () => {
  if (!props.service?.id) return
  isSaving.value = true

  const {
    name,
    description,
    scopeServiceGroupId,
    availableForMissions,
    averageDuration,
    priceMax,
    priceMin,
  } = form.value

  const result = await mutate<UpdateScopeServiceMutationMutation>({
    mutation: UpdateScopeServiceMutation,
    variables: {
      scopeServiceId: props.service.id,
      scopeServiceInput: {
        name,
        description,
        scopeServiceGroupId,
        availableForMissions,
        averageDuration,
        priceMax,
        priceMin,
      },
    },
    done: () => (isSaving.value = false),
  })

  if (!result?.data?.updateScopeService?.error) {
    emit("save")
    addSuccess("Service updated successfully")
    reset()
  }
}

const onCancel = () => {
  reset()
  emit("close")
  return false
}

const reset = () => {
  form.value = { ...defaultForm }
  observer.value && (observer.value as any).reset()
}

onMounted(() => {
  populateForm()
})

return { __sfc: true,props, emit, addSuccess, mutate, loading, onResult, isSaving, observer, serviceGroups, defaultForm, form, populateForm, refetchQueries, onSave, createService, updateService, onCancel, reset, Checkbox, MoneyInput }
}

})